<template>
  <div class="products-input-observer">
    <component
      :is="targetComponent"
      :require-prof="requireProf"
      :standard-recommend-data="standardRecommendData"
      :csrf-token="csrfToken"
    />
    <lp-footer
      :color-scheme="targetColorScheme"
      :menu-list="footerMenuList"
      :scroll-pos="scrollPos"
      :lp-id="6"
    />
  </div>
</template>

<script>
import ProductsInput01 from './fortunes/ProductsInput01'
import { BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'

export default {
  name: 'ProductsSomariResult',
  components: {
    LpFooter
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
    standardRecommendData: {
      type: Array,
    },
    requireProf: {
      type: Array,
      default: null,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data() {
    return {
      scrollPos: -1,
    }
  },
  computed: {
    targetColorScheme() {
      const sch = BASIC_DATA.somarimone.colorScheme
      return {
        keyColor: sch.baseBg,
        fontColor: 'white',
        second: '#ffd69b',
      }
    },
    footerMenuList() {
      return [
        { label: `そまり百音TOP`, url: `/products/44`},
        ...DEFAULT_FOOTER_MENULIST,
      ]
    },
    targetComponent(){
      switch (this.pageId) {
        case '0001':
          return ProductsInput01
      }
    }
  },
  created() {
    console.log('[ products-page: %s ]', this.pageId)
    console.log(' requireProf: %O', this.requireProf)
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll(){
      this.scrollPos = window.scrollY
    },
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../sass/commons/commonVariables.scss";


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/somarimone/ProductsSomariInput.vue